import React from 'react';
import ContracsWithErrorsList from './ContracsWithErrorsList';

function createAlerts({ requests, responses, mode }) {
    const alertsWithErrors = responses.filter(({ status }) => status === 500);

    const alertsWithConflicts = responses.filter(({ status }) => status === 409);

    const qtdAlertsWithErrors = alertsWithErrors.length;

    const alerts = [];

    if (requests.length !== qtdAlertsWithErrors && qtdAlertsWithErrors === 0 && alertsWithConflicts.length === 0) {
        alerts.push({
            type: 3,
            title: mode === 'register' ? 'Cadastro realizado com sucesso' : 'Atualização realizada com sucesso.',
        });
    }

    if (qtdAlertsWithErrors > 0) {
        alerts.push({
            type: 1,
            title: `1 ou mais contratos não foram atualizados com sucesso:`,
            message: <ContracsWithErrorsList list={alertsWithErrors} />,
        });
    }

    if (alertsWithConflicts.length > 0) {
        alerts.push({
            type: 1,
            title: `E-mail informado já cadastrado nos contratos indicados abaixo. Para realizar a edição dos dados, acesse a aba "Usuários cadastrados".`,
            message: <ContracsWithErrorsList list={alertsWithConflicts} />,
        });
    }

    return alerts;
}

export default createAlerts;
